import { TableCellProps } from "@material-ui/core";
import React from "react";
import { TableHeaderCell } from "./TableHeaderCell";

export type TableHeaderCellActionProps = TableCellProps & {
}

export function TableHeaderCellAction (props: TableHeaderCellActionProps) {
    return (
        <TableHeaderCell {...props}>Ações</TableHeaderCell>
    )
}